<div class="transferring-students">
  <mat-dialog-content>
    <p class="transfer-notification">
      Перевод должен использоваться только при схлопывании групп. Если надо
      перекинуть одного студента без схлопывания групп, то студента нужно
      отчислить и добавить в новую группу.
    </p>

    <form [formGroup]="filterForm">
      <mat-form-field appearance="outline">
        <mat-label>Выберите курс</mat-label>
        <mat-select required formControlName="course">
          <mat-option *ngFor="let course of courses" [value]="course.id">
            {{ course.title }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div class="mb-3">
        <mat-form-field appearance="outline">
          <mat-label>Выберите группу</mat-label>
          <mat-select required formControlName="group">
            <mat-option *ngFor="let group of groups" [value]="group.id">
              {{ group.full_name }}
            </mat-option>
          </mat-select>
          <mat-hint
            >Чтобы поле с выбором группы стало активным, нужно выбрать
            курс</mat-hint
          >
        </mat-form-field>
      </div>

      <div class="mb-3">
        <app-search-field
          class="w-100 mb-3"
          fillClass="outline"
          [isDisabled]="isDisabledSearchField()"
          (searchHandler)="searchUsers($event)"
          label="Введите имя либо фамилию студента"
          helperText="Чтобы поле с поиском стало активным, нужно выбрать группу"></app-search-field>
      </div>

      <app-loader *ngIf="loading$ | async"></app-loader>
      <p *ngIf="students && students.length === 0">Список пользователей пуст</p>
      <ng-container *ngIf="(loading$ | async) === false">
        <ul class="students-list">
          <li class="d-flex justify-content-between align-items-center">
            <span class="col-5">Кол-во: {{ checkedUsers.size }}</span>
            <mat-checkbox
              class="col-5"
              [disabled]="!this.filterForm.controls.group.value"
              *ngIf="!searchValue"
              [checked]="isAllChecked"
              (change)="setAll()">
              Выбрать всех
            </mat-checkbox>
          </li>
          <li *ngFor="let student of students" class="students-list-item">
            <mat-checkbox
              [disabled]="!this.filterForm.controls.group.value"
              (change)="toggleCheckUser(student.id)"
              [checked]="isUserChecked(student.id)"
              color="primary">
              {{ student.full_name }}
            </mat-checkbox>
          </li>
        </ul>
      </ng-container>
    </form>
  </mat-dialog-content>
  <div mat-dialog-actions>
    <button type="button" class="mr-2" mat-raised-button (click)="onCancel()">
      Отмена
    </button>
    <app-button-with-progress
      label="Подтвердить"
      (click)="onSubmit()"
      [isDisabled]="isDisabledSubmitButton()"
      [loading$]="sendLoading$ | async"></app-button-with-progress>
  </div>
</div>
